export const SET_LOCATIONS = "SET_LOCATIONS"
